<template>
    <div class="w-full max-w-120 rounded shadow-xl | transition duration-300">
        <form class="p-6 rounded bg-white space-y-6" @submit.prevent="resetPassword">
            <p class="text-center" v-text="$t('auth.newPassword.instructions')" />

            <div class="space-y-3">
                <nio-input
                    :placeholder="$t('auth.newPassword.password')"
                    required
                    type="password"
                    v-model="password"
                />
                <nio-input
                    :placeholder="$t('auth.newPassword.passwordConfirmation')"
                    required
                    type="password"
                    v-model="passwordConfirmation"
                />
            </div>

            <nio-button
                class="w-full"
                color="blue"
                :disabled="!valid"
                type="submit"
            >
                {{ $t('auth.newPassword.changePassword') }}
            </nio-button>

            <nio-alert type="error" v-if="errors.length">
                <div :key="error" v-for="error in errors">
                    {{ error }}
                </div>
            </nio-alert>
        </form>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        props: {
            email: {
                type: String,
                required: true,
            },
            token: {
                type: String,
                required: true,
            },
            locale: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                password: '',
                passwordConfirmation: '',
                errors: [],
                loading: false,
            };
        },

        computed: {
            valid() {
                return !empty(this.password) &&
                    !empty(this.passwordConfirmation) &&
                    this.password.length >= 8 &&
                    this.passwordConfirmation.length >= 8 &&
                    !this.errors.length;
            },
        },

        watch: {
            password() {
                this.errors = [];
            },

            passwordConfirmation() {
                this.errors = [];
            },
        },

        methods: {
            ...mapActions([
                'clearAuthUser',
            ]),

            async resetPassword() {
                if (!this.valid) {
                    return;
                }

                this.loading = true;

                try {
                    await this.$axios.post('password/reset', {
                        email: this.email,
                        password: this.password,
                        password_confirmation: this.passwordConfirmation,
                        user_type: this.$route.query.userType,
                        token: this.token,
                    });

                    this.$notify.show({
                        type: 'success',
                        message: this.$t('auth.newPassword.passwordChanged'),
                    });
                    if (this.$route.query.userType === 'user') {
                        this.clearAuthUser({
                            name: 'auth.login',
                            query: { e: this.email },
                        });
                    } else {
                        window.location.href = process.env.VUE_APP_NOVA_URL;
                    }
                } catch (error) {
                    const errors = error.response.data.errors;

                    Object.keys(errors).forEach(key => {
                        errors[key].forEach(error => {
                            this.errors.push(error);
                        });
                    });
                }

                this.loading = false;
            },
        },

        created() {
            if (this.locale) {
                this.$i18n.locale = this.locale;
            }
        },
    };
</script>
